import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoFormPanelConfig,
} from 'ngx-eo-web-components';

export const surgeryAssignFormPanel = new EoFormPanelConfig({
  name: 'surgeryAssignForm',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'availability',
      styleClass: 'col-12',
      label: 'Διαθεσιμότητα',
      control: new FormControl(null, [Validators.required]),
    }),
  ],
});

export const surgeryAssignFormConfig: EoFormPanelConfig[] = [surgeryAssignFormPanel];

export const getFormControlValue = (formConfig: EoFormPanelConfig[], formGroupName: string, formControlName: string): any => {
  return formConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.value;
};

export const getAvailabilityValue = (): any => {
  return getFormControlValue(surgeryAssignFormConfig, 'surgeryAssignForm', 'availability');
};

